"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const currency_1 = require("../../config/currency");
const json_1 = require("../../json");
const constants_1 = require("./constants");
const validateCurrencyCodes = (arr) => {
    const notSupportedCurrency = arr.filter(country => !Object.keys(currency_1.supportedCurrency).includes(country));
    if (notSupportedCurrency.length !== 0) {
        throw new Error(`Переданы валюты, которые клиент не поддерживает [${notSupportedCurrency.join(', ')}]`);
    }
    return arr;
};
const validateLanguages = (arr) => {
    const notSupportedLanguages = arr.filter(language => !Object.keys(json_1.availableLocales).includes(language));
    if (notSupportedLanguages.length !== 0) {
        throw new Error(`Переданы языки, которые клиент не поддерживает [${notSupportedLanguages.join(', ')}]`);
    }
    return arr;
};
const localizationReducer = (state, action) => {
    switch (action.type) {
        case constants_1.SET_AVAILABLE_CURRENCIES:
            const availableCurrencies = validateCurrencyCodes(action.payload);
            return { ...state, availableCurrencies };
        case constants_1.SET_AVAILABLE_LANGUAGES:
            const availableLanguages = validateLanguages(action.payload);
            return { ...state, availableLanguages };
        case constants_1.SET_SELECTED_CURRENCY:
            return { ...state, selectedParameters: {
                    ...state.selectedParameters,
                    currencyCode: action.payload
                } };
        case constants_1.SET_SELECTED_LANGUAGE:
            return { ...state, selectedParameters: {
                    ...state.selectedParameters,
                    language: action.payload
                } };
        default:
            return { ...state };
    }
};
exports.default = localizationReducer;
